import { useEffect, useState } from "react";

import Navbar from "../../Components/Navbar";
import { useNavigate } from "react-router-dom";
import { getAllOrgUserGeneralFaq } from "../../api/FAQ/Admin/GenralFAQ/getAllOrgUserGeneralFaq";
import { useAuthContext } from "../../hooks";
import { getAllAnonymousQueries } from "../../api/FAQ/Admin/AnonymousFAQ/getAnonymousFaq";
import AdminFaqSc from "./index.sc";
import { getOrgPersonalQueries } from "../../api/FAQ/Admin/PersonalFAQ/getAllPersonalQueries";
import { getUsers } from "../../api/users/getUsers";
function Tabs() {
  const auth = useAuthContext();
  const navigate = useNavigate();
  const [toggleState, setToggleState] = useState(1);
  function toggleTab(index: any) {
    setToggleState(index);
  }

  const [genralFaq, setGeneralFaq] = useState<any>([]);
  const fetchOrgGenralFaq = async () => {
    await getAllOrgUserGeneralFaq(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        setGeneralFaq(e);
      })
      .catch((e) => console.log(e));
  };
  const [anonymous, setAnonymous] = useState<any>([]);
  const fetchAllAnonymousFaq = async () => {
    await getAllAnonymousQueries(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        setAnonymous(e);
      })
      .catch((e) => console.log(e));
  };
  const [orgUsers, setOrgUsers] = useState<any>([]);
  const fetchAllOrgUsers = async () => {
    await getUsers(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        setOrgUsers(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    // fetchOrgGenralFaq();
    // fetchAllAnonymousFaq();
    fetchAllOrgUsers();
  }, []);
  console.log(genralFaq);
  return (
    <AdminFaqSc>
      <div className="admin-faq-navbar">
        <div className="container">
          <div className="bloc-tabs">
            <button
              className={toggleState === 1 ? "tabs active-tabs" : "tabs"}
              onClick={() => toggleTab(1)}
            >
              General Issues
            </button>
            <button
              className={toggleState === 2 ? "tabs active-tabs" : "tabs"}
              onClick={() => toggleTab(2)}
            >
              Anonymous Queries
            </button>
          </div>
        </div>
      </div>

      <div className="content-tabs">
        <div
          className={toggleState === 1 ? "content  active-content" : "content"}
        >
          <label>General Faq</label>
          <div className="query-conatiner-list">
            <table>
              <tr>
                <th className="heading">S.no</th>
                <th className="heading">Name</th>
                <th className="heading">Queries Type</th>
              </tr>
              {genralFaq?.map((data: any, idx: any) => {
                return (
                  <>
                    <tr key={idx} onClick={() => navigate(`${data?.faq_id}`)}>
                      <td>{idx + 1}</td>
                      <td>{data?.Name}</td>
                      <td>{data?.faq_type_name}</td>
                    </tr>
                  </>
                );
              })}
            </table>
          </div>
          <label>PersonalFaq</label>
          <div className="query-conatiner-list">
            <table>
              <tr>
                <th className="heading">S.no</th>
                <th className="heading">Name</th>
                <th className="heading">Designation</th>
              </tr>
              {orgUsers?.map((data: any, idx: any) => {
                return (
                  <>
                    <tr
                      key={idx}
                      onClick={() => navigate(`users/${data?.org_user_id}`)}
                    >
                      <td>{idx + 1}</td>
                      <td>{data?.first_name + data?.last_name}</td>
                      <td>{data?.org_role}</td>
                    </tr>
                  </>
                );
              })}
            </table>
          </div>
        </div>
        <div className="active-anonymous">
          <div
            className={
              toggleState === 2 ? "content  active-content" : "content"
            }
          >
            <div className="anonymous-container">
              <div className="anonymous-main-list">
                <table>
                  <tr>
                    <th className="heading">Anonymous Id</th>
                    <th className="heading">Anonymous Title</th>
                    {/* <th className="heading">Queries Type</th> */}
                  </tr>
                  {anonymous?.map((data: any, idx: any) => {
                    return (
                      <>
                        <tr key={idx}>
                          <td>{data?.aq_id}</td>
                          <td>{data?.aq_queries}</td>
                          {/* <td>{data?.faq_type_name}</td> */}
                        </tr>
                      </>
                    );
                  })}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminFaqSc>
  );
}

export default Tabs;
